import createReducers, { RootActions } from './reducers';
import matches from './reducers/matches';
import sports from './reducers/sports';
import tournamentStages from './reducers/stages';
import tournaments from './reducers/tournaments';
import tournamentUnions from './reducers/unions';

// ---

const ENTITIES_REDUCERS = {
  sports,
  tournamentUnions,
  tournaments,
  tournamentStages,
  matches,
};

export function createEntitiesReducer(triggerAction: RootActions) {
  return createReducers(ENTITIES_REDUCERS, triggerAction);
}

// ---

const MENU_REDUCERS = {
  sports,
  tournamentUnions,
  tournaments,
  tournamentStages,
};

export function createMenuReducer(triggerAction: RootActions) {
  return createReducers(MENU_REDUCERS, triggerAction);
}
